import { createStore } from '@orderx/lab/xr/store';

interface ZoneData {
    origin: 'TAG' | 'BROWSE' | 'PATH';
    value?: any;
}

type Store = { [key: number]: ZoneData };

const { useStore } = createStore<Store>({});

export function useZoneHistory() {
    const [state, setState] = useStore();

    return {
        getHistory(zoneId: number) {
            return state[zoneId];
        },
        setPath(zoneId: number, path: string) {
            setState((state) => {
                state[zoneId] = {
                    origin: 'PATH',
                    value: path,
                };
            });
        },
        clearHistory(zoneId: number) {
            setState((state) => {
                state[zoneId] = {} as any;
            });
        },
    };
}
